import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function RegistrationComplete() {
  const navigate = useNavigate();

  return (
    <div className="row g-0 p-0 align-items-center justify-content-center">
      <div className="col-md-6 p-0 text-center">
        <h1 className="mb-4">Thank You!</h1>
        <p>
          Congrats! Your registration has been completed successfully. Now you
          can start exploring our services, register your children and do a lot
          more.
        </p>
        <Button
          variant="primary"
          className="me-lg-2 me-0 mb-lg-0 mb-2"
          onClick={() => navigate("/")}
        >
          Go to Dashboard
        </Button>
        <Button variant="primary" onClick={() => navigate("/children")}>
          Register Children
        </Button>
      </div>
    </div>
  );
}
